import React from "react";

import { MyAccountComponent } from "../../components/MyAccountComponent/MyAccountComponent";
import Page from "../page-layout";

const MyAccountPage: React.FC = () => {
  return (
    <Page>
      <Page.HeaderMobile />
      <Page.Content>
        <MyAccountComponent />
      </Page.Content>
    </Page>
  );
};

export { MyAccountPage };
